module.exports = __webpack_public_path__ + "img/peter_huber.8dd08cc8.png";